"use client";

import { cn } from "@/lib/utils";
import Link from "@app/_components/Link";
import { useHeaderContext } from "@app/_context/headerContext";

export default function SiteLogo({ locale }: { locale: string }) {
  const { hasScrolled } = useHeaderContext();

  return (
    <Link locale={locale} className="relative grid shrink-0 place-items-center">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        fetchPriority="high"
        src="/images/no-ga-wordmark.svg"
        alt="NO GA wordmark"
        width={384}
        height={40}
        className={cn(
          "col-start-1 row-start-1 block h-10 w-full place-self-center object-contain transition-all duration-300 ease-out lg:h-13",
          hasScrolled
            ? "-translate-y-4 opacity-0"
            : "translate-y-0 opacity-100",
        )}
      />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        fetchPriority="high"
        src="/images/no-ga-logo.svg"
        alt="NO GA logo"
        width={128}
        height={40}
        className={cn(
          "col-start-1 row-start-1 block h-10 w-full place-self-center object-contain transition-all duration-300 ease-out lg:h-13",
          hasScrolled ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0",
        )}
      />
    </Link>
  );
}
